import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Branded pin using a divIcon (avoids webpack marker-image issues).
function makePin(label) {
  return L.divIcon({
    className: 'uae-pin',
    html: `<div style="transform:translate(-50%,-100%)">
      <div style="background:linear-gradient(100deg,#CBA344,#B68A35);color:#fff;font:600 12px Inter,sans-serif;padding:4px 9px;border-radius:999px;white-space:nowrap;box-shadow:0 6px 16px -4px rgba(182,138,53,.6)">${label}</div>
      <div style="width:10px;height:10px;background:#B68A35;transform:rotate(45deg);margin:-5px auto 0;border-radius:2px"></div>
    </div>`,
    iconSize: [0, 0],
  });
}

const HotelMap = ({ hotels }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  // init once
  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;
    const map = L.map(containerRef.current, { scrollWheelZoom: false }).setView([24.8, 54.6], 7);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 18,
    }).addTo(map);
    layerRef.current = L.layerGroup().addTo(map);
    mapRef.current = map;
    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, []);

  // update markers when hotels change
  useEffect(() => {
    const map = mapRef.current;
    const layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();
    const pts = [];
    (hotels || []).forEach((h) => {
      if (typeof h.lat !== 'number' || typeof h.lng !== 'number') return;
      const marker = L.marker([h.lat, h.lng], { icon: makePin(h.priceLabel ? h.priceLabel.replace(' / night', '') : h.name) });
      marker.bindPopup(
        `<div style="font-family:Inter,sans-serif;min-width:150px">
          <div style="font:600 14px 'Fraunces',serif;color:#1B1D21">${h.name}</div>
          <div style="font-size:12px;color:#2F663C;margin-top:2px">${h.area}, ${h.emirate}</div>
          <div style="font-size:13px;color:#1B1D21;font-weight:600;margin-top:4px">${h.priceLabel || ''}</div>
        </div>`
      );
      marker.addTo(layer);
      pts.push([h.lat, h.lng]);
    });
    if (pts.length === 1) {
      map.setView(pts[0], 11);
    } else if (pts.length > 1) {
      map.fitBounds(L.latLngBounds(pts).pad(0.25));
    } else {
      map.setView([24.8, 54.6], 7);
    }
    setTimeout(() => map.invalidateSize(), 100);
  }, [hotels]);

  return (
    <div
      ref={containerRef}
      className="w-full h-[520px] rounded-2xl overflow-hidden border border-[#E6D7A2] shadow-[0_18px_40px_-28px_rgba(27,29,33,0.45)] z-0"
    />
  );
};

export default HotelMap;
